export default __webpack_public_path__ + "static/media/client16.3a377295.jpg";